import { createAction } from "../creators";

export default {
  ...createAction("SET_DIRECTION", "data"),
};
